import { render, staticRenderFns } from "./AdviceCreate.vue?vue&type=template&id=4107ab66&"
import script from "./AdviceCreate.vue?vue&type=script&lang=js&"
export * from "./AdviceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports